import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Sessions = () => {
  return (
    <React.Fragment>
      <SEO title="Sessions | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Sessions"
        content="The Conference"
        contentTwo="Sessions"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
          <h2>
            The Scheduled Timetable of ALL Presentations for ICSI&apos;2022
          </h2>

          <div className="notice"></div>

          <div className="main-table">
            {/* begin here */}
            <h4>Day I (July 16th)</h4>
            <table className="sessions">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <p className="table-room">Online Room 1</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 2</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 3</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>10:50-11:20</th>
                  <td>
                    {" "}
                    <p className="table-id">9704</p>
                    <p className="table-title">
                      A Bio-Inspired Neural Network Approach to Robot Navigation
                      and Mapping with Nature-Inspired Algorithms
                    </p>
                    <p className="table-authors">
                      Tingjun Lei, Timothy Sellers, Chaomin Luo and Li Zhang
                    </p>{" "}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <table className="sessions">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <p className="table-room">Online Room 1</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 2</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 3</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>13:40-14:00</th>
                  <td>
                    {" "}
                    <p className="table-id">1496</p>
                    <p className="table-title">
                      COVID-19 Detection Method Based on Attentional Mechanism
                      and LSTM
                    </p>
                    <p className="table-authors">Wanpeng Zhu and Xiujuan Lei</p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">0946</p>
                    <p className="table-title">
                      Comparing the Brain Storm Optimization Algorithm on the
                      Ambiguous Benchmark Set
                    </p>
                    <p className="table-authors">
                      Jakub Kudela, Tomas Nevoral and Tomas Holoubek
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">1444</p>
                    <p className="table-title">
                      Copy and Paste: A Multi-Offspring Genetic Algorithm
                      Crossover Operator for the Traveling Salesman Problem
                    </p>
                    <p className="table-authors">
                      Chia E. Tungom, Ben Niu, Tongtong Xing, Hong Wang and Ji
                      Yuan
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>14:00-14:20</th>
                  <td>
                    {" "}
                    <p className="table-id">5869</p>
                    <p className="table-title">
                      Towards Robust Graph Convolution Network via Stochastic
                      Activation
                    </p>
                    <p className="table-authors">
                      Zhengfei Yu, Hao Yang, Lin Wang, Lijian Sun and Yun Zhou
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">1741</p>
                    <p className="table-title">
                      Mine Ventilation Prediction Based on BSO-DG Optimized BP
                      Neural Network
                    </p>
                    <p className="table-authors">
                      Junfeng Chen, Mao Mao and Xueping Zhang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">2267</p>
                    <p className="table-title">
                      Genetic Algorithm for Bayesian Knowledge Tracing: A
                      Practical Application
                    </p>
                    <p className="table-authors">
                      Shuai Sun, Xuegang Hu, Chenyang Bu, Fei Liu, Yuhong Zhang
                      and Wenjian Luo
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>14:20-14:40</th>
                  <td>
                    {" "}
                    <p className="table-id">8684</p>
                    <p className="table-title">
                      Adversarial Examples Are Closely Relevant to Neural
                      Network Models - A Preliminary Experiment Explore
                    </p>
                    <p className="table-authors">
                      Zheng Zhou, Ju Liu and Yanyang Han
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">6842</p>
                    <p className="table-title">
                      Construction of Fuzzy Classifiers by a Brain Storm
                      Optimization Algorithm
                    </p>
                    <p className="table-authors">
                      Marina Bardamova, Ilya Hodashinsky and Mikhail Svetlakov
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">5101</p>
                    <p className="table-title">
                      Reasoning about Order Crossover in Genetic Algorithms
                    </p>
                    <p className="table-authors">
                      M. Saqib Nawaz, Saleha Noor and Philippe Fournier-Viger
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>14:40-15:00</th>
                  <td>
                    {" "}
                    <p className="table-id">1298</p>
                    <p className="table-title">
                      Simpler Is Sometimes Better: Dynamic Aero-Engine
                      Calibration
                    </p>
                    <p className="table-authors">
                      Hao Tong, Qingquan Zhang, Chengpeng Hu, Xudong Feng, Feng
                      Wu and Jialin Liu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">4082</p>
                    <p className="table-title">
                      Solving the Unit Commitment Problem with Improving Binary
                      Particle Swarm Optimization
                    </p>
                    <p className="table-authors">
                      Jianhua Liu, Zihang Wang, Yuxiang Chen and Jian Zhu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">9306</p>
                    <p className="table-title">
                      Offline Data-Driven Evolutionary Optimization Algorithm
                      Using K-Fold Cross
                    </p>
                    <p className="table-authors">
                      Mengzhen Wang, Yawen Shan and Fei Xu
                    </p>{" "}
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="sessions">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <p className="table-room">Online Room 1</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 2</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 3</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>15:20-15:40</th>
                  <td>
                    {" "}
                    <p className="table-id">5337</p>
                    <p className="table-title">
                      A Lung Segmentation Method Based on an Improved Convex
                      Hull Algorithm Combined with Non-uniform Rational B-sample
                    </p>
                    <p className="table-authors">
                      Xianghang Shi, Jing Liu, Jingzhou Xu and Mingli Lu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">9078</p>
                    <p className="table-title">
                      Economic Dispatch Optimization for Microgrid Based on
                      Fireworks Algorithm with Momentum
                    </p>
                    <p className="table-authors">Mingze Li and Ying Tan</p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">7427</p>
                    <p className="table-title">
                      Surrogate-assisted Differential Evolution-based Method for
                      the ICSI&apos;2022 Competition
                    </p>
                    <p className="table-authors">
                      Jakub Kudela, Tomas Holoubek and Tomas Nevoral
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>15:40-16:00</th>
                  <td>
                    {" "}
                    <p className="table-id">5930</p>
                    <p className="table-title">
                      T-Distribution Based BFO for Life Classification Using DNA
                      Codon Usage Frequencies
                    </p>
                    <p className="table-authors">
                      Shuang Yang, Zhipeng Xu, Chen Zou and Gemin Liang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">8848</p>
                    <p className="table-title">
                      An Improved Fireworks Algorithm for Integrated Flight
                      Timetable and Crew Schedule Recovery Problem
                    </p>
                    <p className="table-authors">
                      Xiaobing Gan, Tianwei Zhou, Yuhan Mai, Huifen Zhong,
                      Xiuyun Zhang and Qinge Xiao
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">5593</p>
                    <p className="table-title">
                      Deep-Layered Differential Evolution
                    </p>
                    <p className="table-authors">
                      Kaiyu Wang, Zhenyu Lei, Ziqian Wang, Zhiming Zhang
                      and Shangce Gao
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>16:00-16:20</th>
                  <td>
                    {" "}
                    <p className="table-id">9304</p>
                    <p className="table-title">
                      Similar Feature Extraction Network for Occluded Person
                      Re-identification
                    </p>
                    <p className="table-authors">
                      Xiao Jiang, Ju Liu, Yanyang Han, Lingchen Gu and Xiaoxi
                      Liu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">5540</p>
                    <p className="table-title">
                      Mobile Robot Path Planning Based on Angle Guided Ant
                      Colony Algorithm
                    </p>
                    <p className="table-authors">
                      Yongsheng Li, Yinjuan Huang, Shibin Xuan, Xi Li and Yuang
                      Wu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">7001</p>
                    <p className="table-title">
                      Group Simulated Annealing Algorithm for ICSI-OC 2022
                    </p>
                    <p className="table-authors">
                      Mingyin Zou, Peichen Zhang and Xiaomin Zhu
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>16:20-16:40</th>
                  <td>
                    {" "}
                    <p className="table-id">5623</p>
                    <p className="table-title">
                      Genetic Programming for Ensemble Learning in Face
                      Recognition
                    </p>
                    <p className="table-authors">
                      Tian Zhang, Lianbo Ma, Qunfeng Liu, Nan Li and Yang Liu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">7939</p>
                    <p className="table-title">
                      Implementation of the Test Data Generation Algorithm Based
                      on the Ant Colony Optimization Pheromone Model
                    </p>
                    <p className="table-authors">
                      Konstantin Serdyukov and Avdeenko Tatyana
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">0377</p>
                    <p className="table-title">
                      Differential Evolution with Biased Parameter Adaptation
                      for ICSI-OC 2022 Competition
                    </p>
                    <p className="table-authors">
                      Vladimir Stanovov and Shakhnaz Akhmedova
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>16:40-17:00</th>
                  <td>
                    {" "}
                    <p className="table-id">9489</p>
                    <p className="table-title">
                      A Multi-constraint Deep Semi-supervised Learning Method
                      for Ovarian Cancer Prognosis Prediction
                    </p>
                    <p className="table-authors">
                      Hua Chai, Longyi Guo, Minfan He, Zhongyue Zhang and
                      Yuedong Yang
                    </p>{" "}
                  </td>
                  <td></td>
                  <td>
                    {" "}
                    <p className="table-id">7063</p>
                    <p className="table-title">
                      Composite Evolutionary Strategy and Differential Evolution
                      Method for the ICSI&apos;2022 Competition
                    </p>
                    <p className="table-authors">
                      Jakub Kudela, Tomas Nevoral and Tomas Holoubek
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>17:00-17:20</th>
                  <td>
                    {" "}
                    <p className="table-id">1651</p>
                    <p className="table-title">
                      Swarm Enhanced Attentive Mechanism for Sequential
                      Recommendation
                    </p>
                    <p className="table-authors">
                      Shuang Geng, Gemin Liang, Yuqin He, Liezhen Duan, Haoran
                      Xie and Xi Song
                    </p>{" "}
                  </td>
                  <td></td>
                  <td>
                    {" "}
                    <p className="table-id">9626</p>
                    <p className="table-title">
                      Enhancing Fireworks Algorithm in Local Adaptation and
                      Global Collaboration for Solving ICSI 2022 Benchmark
                      Problems
                    </p>
                    <p className="table-authors">
                      Yifan Liu, Li Yifeng and Ying Tan
                    </p>{" "}
                  </td>
                </tr>
              </tbody>
            </table>
            <h4>Day II (July 17th)</h4>
            <table className="sessions">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <p className="table-room">Online Room 1</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 2</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 3</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>08:40-09:00</th>
                  <td>
                    {" "}
                    <p className="table-id">2284</p>
                    <p className="table-title">
                      Parallel Symbiotic Lion Swarm Optimization Algorithm Based
                      on Latin Hypercube Distribution
                    </p>
                    <p className="table-authors">
                      Zongxin Han and Mingyan Jiang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">7439</p>
                    <p className="table-title">
                      Feature Weighting on EEG Signal by Artificial Bee Colony
                      for Classification of Motor Imaginary Tasks
                    </p>
                    <p className="table-authors">
                      Demison Alves, Otávio Teixeira and Cleison Silva
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">9701</p>
                    <p className="table-title">
                      Multi-Objective Optimization Robot Navigation Through a
                      Graph-driven PSO Mechanism
                    </p>
                    <p className="table-authors">
                      Timothy Sellers, Tingjun Lei, Gene Eu Jan, Ying Wang and
                      Chaomin Luo
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>09:00-09:20</th>
                  <td>
                    {" "}
                    <p className="table-id">4825</p>
                    <p className="table-title">
                      Bean Optimization Algorithm Based on Differential
                      Evolution
                    </p>
                    <p className="table-authors">
                      Yongqiang Hu, Ying Li, Tingjuan Li, Jiaqing Xu, Hang Liu
                      and Changshun Zhang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">1676</p>
                    <p className="table-title">
                      Cooperative Positioning Enhancement for HDVs and CAVs
                      Coexisting Environment using Deep Neural Networks
                    </p>
                    <p className="table-authors">
                      Ao Zhang, Xuting Duan, Jianshan Zhou, Haiying Xia, Long
                      Zhang, He Liu and Wenjuan E
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">2139</p>
                    <p className="table-title">
                      A Deep Reinforcement Learning Approach for Cooperative
                      Target Defense
                    </p>
                    <p className="table-authors">
                      Yanxue Xiong, Zhigang Wang and Liangjun Ke
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>09:20-09:40</th>
                  <td>
                    {" "}
                    <p className="table-id">6481</p>
                    <p className="table-title">
                      An Improved Hydrologic Cycle Optimization Algorithm for
                      Solving Engineering Optimization Problems
                    </p>
                    <p className="table-authors">
                      Haiyun Qiu, Bowen Xue, Ben Niu, Tianwei Zhou and Junrui Lu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">3975</p>
                    <p className="table-title">
                      Stability Analysis of Stochastic Neutral Hopfield Neural
                      Networks with Multiple Time-varying Delays
                    </p>
                    <p className="table-authors">
                      Yongcai Li, Jiqiang Feng and Shengbing Xu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">8993</p>
                    <p className="table-title">
                      Particle Swarm Based Reinforcement Learning
                    </p>
                    <p className="table-authors">
                      Jianyu Duan, Yanxiao Guo, Zhigang Wang and Liangjun Ke
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>09:40-10:00</th>
                  <td>
                    {" "}
                    <p className="table-id">6929</p>
                    <p className="table-title">
                      Research on Spectrum Allocation Algorithm Based on Quantum
                      Lion Swarm Optimization
                    </p>
                    <p className="table-authors">
                      Keqin Jiang and Mingyan Jiang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">5617</p>
                    <p className="table-title">
                      Training Quantized Deep Neural Networks via Cooperative
                      Coevolution
                    </p>
                    <p className="table-authors">
                      Fu Peng, Shengcai Liu, Ning Lu and Ke Tang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">3435</p>
                    <p className="table-title">
                      Advances in Cooperative Target Searching by Multi-UAVs
                    </p>
                    <p className="table-authors">
                      Changjian Wang, Xiaoming Zhang, Yingbo Lei, Hang Wu, Hang
                      Liu and Lele Xie
                    </p>{" "}
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="sessions">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <p className="table-room">Online Room 1</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 2</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 3</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>10:20-10:40</th>
                  <td>
                    {" "}
                    <p className="table-id">3282</p>
                    <p className="table-title">
                      Multi-Objective Evolutionary Ensemble Learning for Disease
                      Classification
                    </p>
                    <p className="table-authors">
                      Nan Li, Lianbo Ma, Tian Zhang and Meirui He
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">7181</p>
                    <p className="table-title">
                      An Improved Convolutional LSTM Network with Directional
                      Convolution Layer for Prediction of Water Quality with
                      Spatial Information
                    </p>
                    <p className="table-authors">
                      Ziqi Zhao, Yuxin Geng and Qingjian Ni
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">3767</p>
                    <p className="table-title">
                      An Efficient Scheduling and Navigation Approach for
                      Warehouse Multi-Mobile Robots
                    </p>
                    <p className="table-authors">
                      Kang Zhao, Benlian Xu, Mingli Lu, Jian Shi and Zhen Li
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>10:40-11:00</th>
                  <td>
                    {" "}
                    <p className="table-id">3932</p>
                    <p className="table-title">
                      An Improved Multi-objective Optimization Algorithm Based
                      on Reinforcement Learning
                    </p>
                    <p className="table-authors">
                      Jun Liu, Yi Zhou, Yimin Qiu and Zhongfeng Li
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">9986</p>
                    <p className="table-title">
                      Task Offloading Decision Algorithm for Vehicular Edge
                      Network Based on Multi-dimensional Information Deep
                      Learning
                    </p>
                    <p className="table-authors">
                      Xi Hu, Yang Huang, Yicheng Zhao, Chen Zhu, Zhibo Su and
                      Rui Wang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">5645</p>
                    <p className="table-title">
                      Hybrid Topology-based Particle Swarm Optimizer for
                      Multi-source Location Problem in Swarm Robots
                    </p>
                    <p className="table-authors">
                      Junqi Zhang, Yehao Lu and Mengchu Zhou
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>11:00-11:20</th>
                  <td>
                    {" "}
                    <p className="table-id">4516</p>
                    <p className="table-title">
                      Fuzzy Multi-objective Particle Swarm Optimization Based on
                      Linear Differential Decline
                    </p>
                    <p className="table-authors">
                      Nana Li, Lian Yuan, Xiaoli Shu, HuaYao Han, Jie Yang and
                      Yanmin Liu
                    </p>{" "}
                  </td>
                  <td></td>
                  <td>
                    {" "}
                    <p className="table-id">5520</p>
                    <p className="table-title">
                      Decentralized Supply Chain Optimization via Swarm
                      Intelligence
                    </p>
                    <p className="table-authors">
                      Karan Singh, Hsin-Ping Liu, Frederick Kin Hing Phoa,
                      Shau-Ping Lin and Yun-Heh Jessica Chen-Burger
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>11:20-11:40</th>
                  <td>
                    {" "}
                    <p className="table-id">6685</p>
                    <p className="table-title">
                      Multi-Objective Evolutionary Algorithm for Reactive Power
                      Optimization of Distribution Network Connecting with
                      Renewable Energies and EVs
                    </p>
                    <p className="table-authors">
                      Biao Xu, Guiyuan Zhang, Xiaoshun Zhang, Ke Li, Yao Yao,
                      Zhun Fan and Yonggang Zhang
                    </p>{" "}
                  </td>
                  <td></td>
                  <td>
                    {" "}
                    <p className="table-id">3747</p>
                    <p className="table-title">
                      Network Community Detection via an Improved Swarm
                      Intelligence Approach
                    </p>
                    <p className="table-authors">
                      Wei-Hsiang Sun and Frederick Kin Hing Phoa
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>11:40-12:00</th>
                  <td>
                    {" "}
                    <p className="table-id">9281</p>
                    <p className="table-title">
                      Layout Optimization of Indoor Obstacle Using a Multimodal
                      Multi-objective Evolutionary Algorithm
                    </p>
                    <p className="table-authors">
                      Tianrui Wu, Qingqing Liu, Weili Wang and Qinqin Fan
                    </p>{" "}
                  </td>
                  <td></td>
                  <td>
                    {" "}
                    <p className="table-id">inv-1</p>
                    <p className="table-title">
                      Information Utilization Ratio in Heuristic Optimization
                      Algorithms
                    </p>
                    <p className="table-authors">Junzhi Li and Ying Tan</p>{" "}
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="sessions">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <p className="table-room">Online Room 1</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 2</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 3</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>13:00-13:20</th>
                  <td>
                    {" "}
                    <p className="table-id">1136</p>
                    <p className="table-title">
                      Dynamic Multi-Swarm Particle Swarm Optimization with
                      Center Learning Strategy
                    </p>
                    <p className="table-authors">
                      Zijian Zhu, Tian Zhong, Chenhan Wu and Bowen Xue
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">0875</p>
                    <p className="table-title">
                      Modelling and Analysis of Cascade Digital Circuit System
                      Based on DNA Strand Displacement
                    </p>
                    <p className="table-authors">
                      Hui Lv, Tao Sun and Qiang Zhang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">4020</p>
                    <p className="table-title">
                      Feature Selection for EEG Data Classification with WEKA
                    </p>
                    <p className="table-authors">
                      Marina Murtazina and Tatiana Avdeenko
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>13:20-13:40</th>
                  <td>
                    {" "}
                    <p className="table-id">1265</p>
                    <p className="table-title">
                      A Surrogate-assisted Ensemble Particle Swarm Optimizer for
                      Feature Selection Problems
                    </p>
                    <p className="table-authors">
                      Jiang Zhi, Zhang Yong, Song Xian-Fang and He Chunlin
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">3043</p>
                    <p className="table-title">
                      LACNNER: Lexicon-Aware Character Representation for
                      Chinese Nested Named Entity Recognition
                    </p>
                    <p className="table-authors">
                      Zhikun Yang, Shumin Shi, Junyu Tian, En Li and Heyan Huang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">4989</p>
                    <p className="table-title">
                      Modified Correlation-based Feature Selection for
                      Intelligence Estimation based on Resting State EEG Data
                    </p>
                    <p className="table-authors">
                      Tatiana Avdeenko, Anastasiia Timofeeva and Marina
                      Murtazina
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>13:40-14:00</th>
                  <td>
                    {" "}
                    <p className="table-id">1717</p>
                    <p className="table-title">
                      Generational Exclusion Particle Swarm Optimization with
                      Central Aggregation Mechanism
                    </p>
                    <p className="table-authors">
                      Chenhan Wu, Zijian Zhu, Tian Zhong and Chen Zou
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">6125</p>
                    <p className="table-title">
                      Extreme Learning Machine Based on Adaptive Matrix
                      Iteration
                    </p>
                    <p className="table-authors">
                      Yuxiang Li, Weidong Zou, Can Wang and Yuanqing Xia
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">inv-2</p>
                    <p className="table-title">
                      Non-dominated Sorting Based Fireworks Algorithm for
                      Multi-objective Optimization
                    </p>
                    <p className="table-authors">Mingze Li and Ying Tan</p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>14:00-14:20</th>
                  <td>
                    {" "}
                    <p className="table-id">4785</p>
                    <p className="table-title">
                      Alternative Learning Particle Swarm Optimization for
                      Aircraft Maintenance Technician Scheduling
                    </p>
                    <p className="table-authors">
                      Tian Zhong, Chenhan Wu, Zijian Zhu and Zhenzhen Zhu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">7770</p>
                    <p className="table-title">
                      Two-replacements Policy Island Model on GPU
                    </p>
                    <p className="table-authors">Faiza Amin and Jinlong Li</p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">0843</p>
                    <p className="table-title">
                      Multi-objective Evolutionary Algorithm with Adaptive
                      Fitting Dominant Hyperplane
                    </p>
                    <p className="table-authors">
                      Zhiqi Zhang, Limin Wang, Xin Yang, Xuming Han and Lin Yue
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>14:20-14:40</th>
                  <td>
                    {" "}
                    <p className="table-id">7291</p>
                    <p className="table-title">
                      An Improved Particle Swarm Optimization Algorithm for
                      Irregular Flight Recovery Problem
                    </p>
                    <p className="table-authors">
                      Tianwei Zhou, Pengcheng He, Churong Zhang, Yichen Lai,
                      Huifen Zhong and Xusheng Wu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">8443</p>
                    <p className="table-title">
                      An Incremental Extreme Learning Machine Prediction Method
                      based on Attenuated Regularization Term
                    </p>
                    <p className="table-authors">
                      Can Wang, Yuxiang Li, Weidong Zou and Yuanqing Xia
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">6116</p>
                    <p className="table-title">
                      Multi-Objective Bacterial Colony Optimization Based on
                      Multi-Subsystem for Environmental Economic Dispatching
                    </p>
                    <p className="table-authors">
                      Hong Wang, Yixin Wang, Mengjie Wan, Sili Wen and Shan Wei
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>14:40-15:00</th>
                  <td>
                    {" "}
                    <p className="table-id">9027</p>
                    <p className="table-title">
                      Improved Aircraft Maintenance Technician Scheduling with
                      Task Splitting Strategy Based on Particle Swarm
                      Optimization
                    </p>
                    <p className="table-authors">
                      Bowen Xue, Haiyun Qiu, Ben Niu and Xiaohui Yan
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">8574</p>
                    <p className="table-title">
                      Kernel Discriminative Classifiers in Risk Prediction of
                      Coronary Heart Disease
                    </p>
                    <p className="table-authors">
                      Hanli Qiao, Huazhou Chen, Jingyi Lyu and Quanxi Feng
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">1017</p>
                    <p className="table-title">
                      Artificial Potential Field Method with Predicted State and
                      Input Threshold for Multi-Agent System
                    </p>
                    <p className="table-authors">
                      Dengxiu Yu, Zhize Du and Zhen Wang
                    </p>{" "}
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="sessions">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <p className="table-room">Online Room 1</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 2</p>
                  </th>
                  <th>
                    <p className="table-room">Online Room 3</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>15:20-15:40</th>
                  <td>
                    {" "}
                    <p className="table-id">1797</p>
                    <p className="table-title">
                      Reinforced Event-Driven Evolutionary Algorithm Based on
                      Double Deep Q-network
                    </p>
                    <p className="table-authors">
                      Tianwei Zhou, Wenwen Zhang, Junrui Lu, Pengcheng He and
                      Keqin Yao
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">9728</p>
                    <p className="table-title">
                      Simple Flow-based Contrastive Learning for BERT Sentence
                      Representations
                    </p>
                    <p className="table-authors">
                      Ziyi Tian, Qun Liu, Wei Deng and Maotao Liu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">5958</p>
                    <p className="table-title">
                      Self-Organizing Mobile Robots Swarm Movement Control
                      Simulation
                    </p>
                    <p className="table-authors">
                      Eugene Larkin, Tatiana Akimenko and Alexey Bogomolov
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>15:40-16:00</th>
                  <td>
                    {" "}
                    <p className="table-id">5529</p>
                    <p className="table-title">
                      A Micro-Population Evolution Strategy for Loser-Out
                      Tournament-Based Firework Algorithm
                    </p>
                    <p className="table-authors">
                      Mingzhang Han, Mingjie Fan, Ning Han and Xinchao Zhao
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">2411</p>
                    <p className="table-title">
                      Research on the Optimal Management Plan of Forests
                    </p>
                    <p className="table-authors">
                      Yifan Jiang, Yuxuan Liu and Jiaze Li
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">0246</p>
                    <p className="table-title">
                      Image Denoising Method of Auto-Evolving PCNN Model Based
                      on Quantum Selfish Herd Algorithm
                    </p>
                    <p className="table-authors">
                      Hongyuan Gao, Haijun Zhao and Shicong Chen
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>16:00-16:20</th>
                  <td>
                    {" "}
                    <p className="table-id">7594</p>
                    <p className="table-title">
                      UAV path planning based on hybrid differential evolution
                      with fireworks algorithm
                    </p>
                    <p className="table-authors">
                      Xiangsen Zhang and Xiangyin Zhang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">2555</p>
                    <p className="table-title">
                      Optimal Synthesis of a Motion generation Six-bar Linkage
                    </p>
                    <p className="table-authors">
                      Pakin Phromphan, Jirachot Suvisuthikasame, Metas
                      Kaewmongkol, Woravech Chanpichitwanich and Suwin
                      Sleesongsom
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">4363</p>
                    <p className="table-title">
                      An Improved Hunger Games Search Algorithm for Global
                      Optimization
                    </p>
                    <p className="table-authors">
                      Shaolang Li, Xiaobo Li, Hui Chen, Yuxin Zhao and Junwei
                      Dong
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>16:20-16:40</th>
                  <td>
                    {" "}
                    <p className="table-id">7514</p>
                    <p className="table-title">
                      Quantum-Behaved Simple Brain Storm Optimization with
                      Simplex Search
                    </p>
                    <p className="table-authors">
                      Xi Wang, Wei Chen, Qunfeng Liu, Yingying Cao, Shi Cheng
                      and Yanmin Yang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">2786</p>
                    <p className="table-title">
                      Forest Management Based on Carbon Sequestration
                    </p>
                    <p className="table-authors">
                      Wenqi Jiang, Xiaoxue Wang, Jiafeng Ding and Chenkai Fang
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">5046</p>
                    <p className="table-title">
                      A Backbone Whale Optimization Algorithm Based on
                      Cross-stage Evolution
                    </p>
                    <p className="table-authors">
                      Xin Yang, Limin Wang, Zhiqi Zhang, Xuming Han and Lin Yue
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>16:40-17:00</th>
                  <td>
                    {" "}
                    <p className="table-id">6483</p>
                    <p className="table-title">
                      A Novel Intelligent Ant Colony System Based on Blockchain
                    </p>
                    <p className="table-authors">
                      Wei Wu, Haipeng Peng, Lixiang Li, H. Eugene Stanley,
                      Licheng Wang and Jürgen Kurths
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">3840</p>
                    <p className="table-title">
                      Effects of Reservation Profit Level on the Efficiency of
                      Supply Chain Contracts
                    </p>
                    <p className="table-authors">
                      Shoufu Wan, Haiyang Xia and Lijing Tan
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">9635</p>
                    <p className="table-title">
                      Improved Hamming Diversity Measure for Set-based
                      Optimization Algorithms
                    </p>
                    <p className="table-authors">
                      Kyle Erwin and Andries Engelbrecht
                    </p>{" "}
                  </td>
                </tr>
                <tr>
                  <th>17:00-17:20</th>
                  <td>
                    {" "}
                    <p className="table-id">0620</p>
                    <p className="table-title">
                      A General Framework for Intelligent Optimization
                      Algorithms Based on Multilevel Evolutions
                    </p>
                    <p className="table-authors">
                      Chenchen Wang, Caifeng Chen, Ziru Lun, Zhanyu Ye and
                      Qunfeng Liu
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">8671</p>
                    <p className="table-title">
                      Reliability-Based Design Optimization of a Goland Wing
                      with a Two-Step Approach
                    </p>
                    <p className="table-authors">
                      Suwapat Chanu, Alfan Wattanathorn, Moses Senpong and Suwin
                      Sleesongsom
                    </p>{" "}
                  </td>
                  <td>
                    {" "}
                    <p className="table-id">9890</p>
                    <p className="table-title">
                      A Mapping Solution Search Garden Balsam Optimization for
                      Solving Invariant Point Problems
                    </p>
                    <p className="table-authors">Xiaohui Wang and Shengpu Li</p>{" "}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* -------End here -------------- */}
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Sessions;
